var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFlowGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flow Groups") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-8---Data-Map---Data-Flows",
    transform: "translate(-36.000000, -525.000000)",
    fill: "#0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flow-Groups",
    transform: "translate(36.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05,16.94 C6.71826455,16.94 7.26,17.4817355 7.26,18.15 L7.26,21.78 C7.26,22.4482645 6.71826455,22.99 6.05,22.99 L1.21,22.99 C0.541735453,22.99 0,22.4482645 0,21.78 L0,18.15 C0,17.4817355 0.541735453,16.94 1.21,16.94 L6.05,16.94 Z M5.86,18.34 L1.4,18.34 L1.4,21.59 L5.86,21.59 L5.86,18.34 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73,16.94 C16.3982645,16.94 16.94,17.4817355 16.94,18.15 L16.94,21.78 C16.94,22.4482645 16.3982645,22.99 15.73,22.99 L10.89,22.99 C10.2217355,22.99 9.68,22.4482645 9.68,21.78 L9.68,18.15 C9.68,17.4817355 10.2217355,16.94 10.89,16.94 L15.73,16.94 Z M15.54,18.34 L11.08,18.34 L11.08,21.59 L15.54,21.59 L15.54,18.34 Z",
    id: "Rectangle-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.94,0 C17.6082645,0 18.15,0.541735453 18.15,1.21 L18.15,4.84 C18.15,5.50826455 17.6082645,6.05 16.94,6.05 L9.68,6.05 C9.01173545,6.05 8.47,5.50826455 8.47,4.84 L8.47,1.21 C8.47,0.541735453 9.01173545,0 9.68,0 L16.94,0 Z M16.75,1.4 L9.87,1.4 L9.87,4.65 L16.75,4.65 L16.75,1.4 Z",
    id: "Rectangle-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.41,16.94 C26.0782645,16.94 26.62,17.4817355 26.62,18.15 L26.62,21.78 C26.62,22.4482645 26.0782645,22.99 25.41,22.99 L20.57,22.99 C19.9017355,22.99 19.36,22.4482645 19.36,21.78 L19.36,18.15 C19.36,17.4817355 19.9017355,16.94 20.57,16.94 L25.41,16.94 Z M25.22,18.34 L20.76,18.34 L20.76,21.59 L25.22,21.59 L25.22,18.34 Z",
    id: "Rectangle-Copy-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.78,10.19 C22.7846323,10.19 23.6081056,10.9656337 23.6842535,11.9507346 L23.69,12.1 L23.69,18.15 L22.29,18.15 L22.29,12.1 C22.29,11.8496309 22.1095873,11.6413995 21.8716731,11.5982168 L21.78,11.59 L4.84,11.59 C4.58963091,11.59 4.38139946,11.7704127 4.33821678,12.0083269 L4.33,12.1 L4.33,18.15 L2.93,18.15 L2.93,12.1 C2.93,11.0953677 3.70563368,10.2718944 4.69073462,10.1957465 L4.84,10.19 L21.78,10.19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    points: "14.01 4.84 14.01 16.94 12.61 16.94 12.61 4.84"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlowGroup);
export default __webpack_public_path__ + "static/media/ic_flow_group.3aba179769dd0b10cf06cce68324884f.svg";
export { ForwardRef as ReactComponent };